import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-dialog-database-backup',
  templateUrl: './dialog-database-backup.component.html',
  styleUrl: './dialog-database-backup.component.scss',
})
export class DialogDatabaseBackupComponent {
  activeTabIndex = 0;

  restoreFile: File | null = null;
  selectedDomains = {
    users: false,
    tenants: false,
    licences: false,
    types: false,
  };

  restoreLoading = false;
  restoreResult: { success: boolean; statements?: number; error?: string } | null = null;

  constructor(
    public dialogRef: MatDialogRef<DialogDatabaseBackupComponent>,
    private dataService: DataService
  ) {}

  backup() {
    this.dataService.backupDatabase();
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.restoreFile = input.files?.[0] ?? null;
    this.restoreResult = null;
  }

  get selectedDomainKeys(): string[] {
    return Object.entries(this.selectedDomains)
      .filter(([, v]) => v)
      .map(([k]) => k);
  }

  restore() {
    if (!this.restoreFile || this.selectedDomainKeys.length === 0) return;
    this.restoreLoading = true;
    this.restoreResult = null;
    this.dataService.restoreDatabase(this.restoreFile, this.selectedDomainKeys).subscribe({
      next: (res) => {
        this.restoreLoading = false;
        this.restoreResult = { success: true, statements: res.statements };
      },
      error: (err) => {
        this.restoreLoading = false;
        this.restoreResult = { success: false, error: err?.error?.error ?? 'Restore fehlgeschlagen' };
      },
    });
  }
}
